import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";

import _ from "lodash";
import cx from "classnames";
import styles from "./dashboard.module.scss";
import { FileService } from "src/utils/file.service";
import { Line, LineChart } from "recharts";
import pluralize from "pluralize";

const DashboardMetrics = () => {
  const loading = useSelector((state: any) =>
    _.get(state.coaching, "reports.teams.dashboard.loading"),
  );

  const metrics = useSelector((state: any) =>
    _.get(state.coaching, "reports.teams.dashboard.item", null),
  );

  if (loading) {
    return (
      <div className={styles.dashboardContainer}>
        <div className={styles.metricsRow}>
          {_.times(6, (index) => (
            <PlaceholderDashboardCard key={index} />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.dashboardContainer}>
      <div className={styles.metricsRow}>
        <DashboardCard value={metrics.learningsPublished || 0} label={`${pluralize('learning',metrics.learningsPublished)} published`} icon="paperflite-rocket" />
        <DashboardCard value={metrics.activePublishers || 0} label="active course creators" icon="paperflite-user-settings-property" />
        <DashboardCard value={metrics.learnersAssigned || 0} label={`${pluralize('enrollment',metrics.learnersAssigned)}`} icon="paperflite-user-settings" />
        <DashboardCard value={metrics.learningsCompleted || 0} label={pluralize("completion",metrics.learningsCompleted)} icon="paperflite-tick-unselected" />
        <DashboardCard value={FileService.formatDuration(metrics.duration || 0, 'short')} label="time spent" icon="paperflite-clock" />
      </div>
    </div>
  );
};

export default DashboardMetrics;

interface DashboardCardProps {
  icon: string;
  label: string,
  value: any;
}


const rawData = [
  { week: "2025-03-03", count: 10 },
  { week: "2025-03-10", count: 20 },
  { week: "2025-03-17", count: 5 },
  { week: "2025-03-24", count: 30 },
];

const calculateMovingAverage = (data, windowSize) => {
  return data.map((_, idx, arr) => {
    const start = Math.max(0, idx - windowSize + 1);
    const window = arr.slice(start, idx + 1);
    const avg = window.reduce((sum, d) => sum + d.count, 0) / window.length;
    return { value: avg };
  });
};


const smoothedData = calculateMovingAverage(rawData, 2);

const DashboardCard: React.FC<DashboardCardProps> = ({ icon, label, value }) => {
  return (
    <div className={styles.metricCard}>
      <div className={styles.metricHeader}>
        <div className={styles.metricValue}>{value}</div>
        {/* <LineChart width={40} height={24} data={smoothedData}>
              <Line
                type="monotone"
                dataKey="value"
                stroke={"#4A90E2"}
                strokeWidth={2}
                dot={false}
              />
            </LineChart> */}
      </div>
      <div className={styles.metricFooter}>
        <div className={styles.metricLabel}>{label}</div>
        <i className={cx(styles.icon, icon)} />
      </div>
    </div>
  );
};

const PlaceholderDashboardCard: React.FC<object> = () => {
  return (
    <div className={cx(styles.metricCard, styles.placeholder)}>
      <div className={cx(styles.metricHeader, styles.block)}>
        <div className={cx(styles.metricValue, styles.block)}> </div>
      </div>
      <div className={cx(styles.metricFooter, styles.block)}>
        <div className={cx(styles.metricLabel, styles.block)}> </div>
        <i className={cx(styles.icon, styles.block)} />
      </div>
    </div>
  );
};
